import Vue from 'vue'
import accounting from "accounting";
import moment from 'moment';

Vue.filter('formatDatebyMoment', function(value, type, format, defaultValue = null) {
    if (!value) return defaultValue;
    if (type) {
        return moment(value, type).format(format);
    } else {
        return moment(value).format(format);
    }
});

Vue.filter('formatMoney', function(value, precision = 2, symbol = '$') {
    if (!value && value != 0) return '-';
    return accounting.formatMoney(value, {
        symbol: symbol,
        precision: precision,
        format: {
            pos: "%s %v",
            neg: "%s (%v)",
            zero: "%s %v"
        }
    });
});
Vue.filter('formatPercent', function(value) {
    if (!value && value != 0) return '0%';
    return (value * 100).toFixed(0) + '%'
});